
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: 'page-builder-store-locator',
})

export default class extends Vue {
  @Prop({default: () => []}) private args!: Array<string>;
  @Prop({default: null}) private route!: string;

  private brandList: Array<object> = [];
  private countryList: Array<object> = [];

  private selectedBrandId: null | number = null;
  private selectedCountry: null | string = null;

  private isLoading: boolean = false;

  private get locale(): string {
    return window.Locale;
  }

  private async getBrandList(): Promise<void> {
    try {
      this.isLoading = true;
      const {data} = await this.$solarClient.get(`api/physical-store/fetch/brands-by-country?country=${this.selectedCountry}`, {
        timeout: 30000,
      });
      this.brandList = data;

      const selectedCountryObject = this.countryList.find((country: object) => country['code'] === this.selectedCountry);
      if (selectedCountryObject) {
        this.$eventBus.$emit('country-selected', selectedCountryObject['name']);
      }

      //Check if current brand is in the list
      if (this.selectedBrandId && ! this.brandList.find((brand: any) => brand['id'] === this.selectedBrandId)) {
        this.selectedBrandId = null;
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  private async getCountryList(): Promise<void> {
    try {
      this.isLoading = true;
      const {data} = await this.$solarClient.get(`api/physical-store/fetch/countries?locale=${this.locale}`);
      this.countryList = data;
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
      this.selectedBrandId = null;
    }
  }

  private get sluggedBrandName(): string {
    return this.selectedBrandId
        ? this.brandList.find((brand: any) => brand['id'] === this.selectedBrandId)['name'].replace(/\s+/g, '-').toLowerCase()
        : '';
  }

  private submitForm(): void {
    const url = this.route || window.location.href;

    this.isLoading = true;

    window.location.href = `${url}/${this.selectedCountry.toLowerCase()}/${this.sluggedBrandName}`;
  }

  private async created(): Promise<void> {
    await this.getCountryList().then(() => {
      if (this.args.length > 0) {
        this.selectedCountry = this.args[0] ? this.args[0].toUpperCase() : null;

        const selectedCountryObject = this.countryList.find((country: object) => country['code'] === this.selectedCountry);
        if (selectedCountryObject) {
          this.$eventBus.$emit('country-selected', selectedCountryObject['name']);
        }

        this.getBrandList().then(() => {
          this.selectedBrandId = this.brandList.find((brand: object) => brand['name'].replace(/\s+/g, '-').toLowerCase() === this.args[1])['id'];
        });
      }
    });
  }
}
